import React from "react";
import styled from "styled-components";

interface Props {
  rowTitle: string,
  charts: JSX.Element[],
}

const StyledRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  & h3 {
    flex: 0 0 auto;
    font-family: AvenirNextLTPro-HeavyCn;
    font-size: 1em;
    margin-bottom: 40px;
    text-transform: none;
  }

  & .charts {
    display: flex;
    flex: 1 0 auto;
    flex-direction: row;
    flex-wrap: wrap;
  }
  
  @media (max-width: 480px) {
    flex: 1 0 auto;
  }
`;

const BranchChartRow = ({ rowTitle, charts }: Props) => {
  return (
    <StyledRow>
      <h3>{ rowTitle }</h3>
      <div className='charts'>
        { charts.map(chart => chart) }
      </div>
    </StyledRow>
  )
};

export default BranchChartRow;
